export const OFFER_TYPES = { KARMA_CASH: 'activateKarmaCash', COUPON: 'coupon' };
